module.exports = __webpack_public_path__ + "img/TV.d1412347.svg";